import UserMiddleContent from './UserMiddleContent';

export default UserMiddleContent;
